<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2">

            چارت سازمانی
        
        </span>

    </div>

</div>

<main class="dir p-3">

    <section class="border border-2 rounded p-3" [ngStyle]="{'max-height' : bChartOption ? '60vh' : '' }" style="overflow: auto;">

        <div class="p-4">

            <div id="jstree" (click)="getNodeIndex($event)" class="rtl"></div>

        </div>

    </section>

    <section *ngIf="bChartOption" class="border border-2 rounded row gx-2 gy-2 p-3 mt-2" style="direction: rtl;">

        <p> گروه کاربری : <b> {{breadCrumb}} </b> </p>

        <!-- شرح -->

        <div class="position-relative col-12 col-md-10 p-2">

            <label class="mb-2 text-muted"> شرح *</label>

            <input class="form-control p-2 text-center" 
            
                #strComment [ngModel]="selectedNode.strComment"
                
                name="strComment" required class="form-control">

        </div>

        <!-- اولویت -->

        <div class="position-relative col-12 col-md-2 p-2">

            <label class="mb-2 text-muted"> اولویت </label>

            <input class="form-control p-2 text-center" 
            
                #iSort [ngModel]="selectedNode.iSort" 
                
                name="iSort" required class="form-control">

        </div>

        <!-- دکمه ها -->

        <div class="row gx-2 gy-2 px-0 col-12">

            <div class="col-auto"> 
                
                <button class="w-100 btn btn-success" 
                
                    (click)="nodeOperation('new',strComment.value,iSort.value)">
                    
                    زیر گروه جدید 
                
                </button> 
            
            </div>

            <div class="col-auto"> 
                
                <button class="w-100 btn btn-primary px-3" 
                
                    (click)="nodeOperation('edit',strComment.value,iSort.value)">
                    
                    ویرایش 
                
                </button>
                
            </div>

            <div class="col-auto"> 
                
                <button class="w-100 btn btn-danger px-3" 
                
                    (click)="nodeOperation('remove')">
                    
                    حذف 
                
                </button> 
            
            </div>

        </div>

    </section>

</main>